import React from "react";
import queryString from 'query-string';
import {connect} from "react-redux";
import {
    addSearchChips,
    fetchSearchResults,
    addSearchFilter,
    clearSearchFilter,
    getFilter,
    fetchSearchData
} from "../../actions/searchActions";
import SearchRow from "./SearchRow";
import SVG from 'react-inlinesvg';
import caretDown from '../../assets/chevron-right-solid.svg';
import Pagination from '../Pagination/Pagination';
import Loading from '../Shared/Loading';
import FilterModal from "../Modal/FilterModal";
import DateFilterModal from "../Modal/DateFilter";

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            units: [],
            column: "",
            direction: "",
            show: false,
            hover: false,
            modalTitle: "",
            options: [],
            title: false,
            mainSearchOptions: [],
            filterOptions: [],
            originalSearchObject: []

        };
        this.filterModal = React.createRef(null);
        this.brand = React.createRef();
        this.campaign = React.createRef(null);
        this.header = React.createRef();
        this.handleSortClick = this.handleSortClick.bind(this);
        this.getSortClass = this.getSortClass.bind(this);
        this.getFilters = this.getFilters.bind(this);

    }
    closeModalResize = () =>{
        this.setState({show: false})
    }
    componentDidMount() {
        let query = this.props.location.search;
        let queryParams = queryString.parse(query);
        let filterOptions = [];
        const chips = [];
        let arr = [];
        for (let prop in queryParams) {
            let unitObj = {};
            if (prop === 'page') {
                continue;
            }
            if(prop === 'sort_col' || prop === 'sort_dir'){
                continue;
            }
            if(prop.includes("filter_")){
                let params = queryParams[prop];
                let type = prop.substring(0, prop.length - 2);
                let value = prop.replace('[]', '');
                if (Array.isArray(params)) {
                    let options = params.map(o => ({
                        name: o,
                        type: type
                    }));
                    filterOptions = [...filterOptions, ...options];
                }else{
                    unitObj['type'] = value;
                    unitObj['name'] = queryParams[prop];
                    filterOptions.push(unitObj);
                }
                continue
            }
            if(prop === 'any[]' || prop === 'any'){
                let value = prop.replace('[]', '');
                unitObj['type'] = value;
                unitObj['name'] = queryParams[prop] === 'true' ? true : false;
                if(!arr.includes(queryParams[prop])){
                    arr = [...arr, unitObj];
                    continue;
                }
            }
            if(prop === 'from_date_format[]' || prop === "to_date_format[]" || prop === 'sort[]'){
                let value = prop.replace('[]', '');
                arr.map(qp => {
                    if (qp.type !== value && qp.name !== queryParams[prop]) {
                        unitObj['type'] = value;
                        unitObj['name'] = queryParams[prop];
                        if(!arr.includes(unitObj)){
                            arr = [...arr, unitObj];
                        }
                    }
                })
                continue;
            }
            if(prop === 'unit_type[]'){
                let value = prop.replace('[]', '');
                if(Array.isArray(queryParams[prop])){
                    let newArr = queryParams[prop].map(function (a) {
                        return {type: value, name: a}
                    });
                    arr = [...arr, ...newArr]
                }else{
                    arr.map(qp => {
                        if(value === "unit_type"){
                            if (qp.name !== queryParams[prop]) {
                                unitObj['type'] = value;
                                unitObj['name'] = queryParams[prop];
                                arr = [...arr, unitObj];
                            }
                        }
                    })
                }
                continue;
            }

            let type = prop.substring(0, prop.length - 2);
            let params = queryParams[prop];
            if (Array.isArray(params)) {
                let options = params.map(o => ({
                    name: o,
                    type: type
                }));
                arr = [...arr, ...options];
                chips.push.apply(chips, options);
            } else {
                let option = {
                    name: params,
                    type: type
                }
                arr = [...arr, option];
                chips.push.apply(chips, [{
                    name: params,
                    type: type
                }]);
            }
        }
        window.addEventListener('resize', this.closeModalResize)
        document.addEventListener("mousedown", this.handleClickOutside);
        let updateState = [...this.state.mainSearchOptions, ...arr];
        let options = [...this.props.searchObj];
        this.setState({mainSearchOptions: updateState, options, filterOptions, originalSearchObject: options})
        this.props.dispatch(getFilter(updateState));
        this.props.dispatch(addSearchChips(chips));
    }

    componentWillUnmount() {
        this.props.dispatch(addSearchChips([]));
        this.props.dispatch(fetchSearchData());
        document.removeEventListener("mousedown", this.handleClickOutside);
        window.removeEventListener('resize', this.closeModalResize)
        this.setState({
            title: false,
            mainSearchOptions: [],
            filterOptions: [],
            options: [],
            originalSearchObject: [],
        })
    }
    componentDidUpdate(prevProps,prevState) {
        let query = this.props.location.search;
        let prevSearch = this.props.mainSearch;
        let prevFilter = this.state.filterOptions;
        let filterSearchOptions = [];
        let primarySearch = [];
        let chips = this.props.chips;
        let prevRecords = this.props.pagination.allRecords;
        let mainSearchOptions = this.state.mainSearchOptions;
        let queryParams = queryString.parse(query);
        let nextPage =  typeof queryParams.page !== 'undefined' && !isNaN(queryParams.page) ? parseInt(queryParams.page, 10) : 1;
        let prevPage = parseInt(prevProps.pagination.current_page, 10);

        if(prevProps.mainSearch.length > 0 && prevProps.mainSearch !== prevSearch || chips !== prevProps.chips){
            mainSearchOptions = prevSearch;
            if(prevProps.mainSearch.length !== 0){
                this.setState({mainSearchOptions, filterOptions: []})
            }
            this.setState({mainSearchOptions})
        }
        if(prevPage !== nextPage && !this.props.loading){
            for (let i in prevFilter) {
                let option1 = prevFilter[i];
                filterSearchOptions.push(option1.type + '[]=' + encodeURIComponent(option1.name).replace(/\s+/g, '+'))
            }
            for (const mainTerm in mainSearchOptions) {
                let mainOptions = mainSearchOptions[mainTerm];
                primarySearch.push(mainOptions.type + '[]=' + encodeURIComponent(mainOptions.name).replace(/\s+/g, '+'))
            }
            let searchParams  = primarySearch.concat(filterSearchOptions);
            this.props.dispatch(addSearchFilter({column: this.props.column, direction: this.props.direction}))
            this.props.dispatch(fetchSearchResults(nextPage, searchParams));
        }
    }

    handleSortClick = (e = null, cat) => {
        let mainSearch = this.state.mainSearchOptions;
        let foptions = this.state.filterOptions;
        let filterUnitTerms = [];
        let search_term = [];
        let options = [...this.props.searchObj];
        let titleArray = ["Seller", "Search By Device", "Search By Demo Type", "Additional Features", "Subcategory"]
        if (cat === "date" || cat === "links") {
            if (this.state.show === true && this.state.title !== cat) {
                this.setState({show: true, title: cat})
            } else {
                this.setState({show: !this.state.show, title: cat})
            }
        }
        else if (cat === "more") {
            let arr = [];
            options = options.filter(o => {
                if(o.title === "Language"){
                    arr = o.options
                }
                if (titleArray.includes(o.title)) {
                    return o;
                }
            });

            if(foptions.length > 0 || mainSearch.length > 3 || mainSearch.length < 3) {
                let additional = ['favorite_id', 'animated', 'demo_links', 'subcategory', 'seller', 'proactive_proposal', 'thumbnail_device_name', 'ppt_location']
                this.props.pagination.allRecords.filter(u => {
                    additional.forEach(term => {
                        if (Object.keys(u).includes(term)) {
                            if (Array.isArray(u[term])) {
                                for (const uKey in u[term]) {
                                    if (term === 'demo_links' && u.unit_type === "live") {
                                        filterUnitTerms.push({
                                            name: u[term][uKey].demo_type,
                                            type: 'search_by_demo_type',
                                        })
                                    } else {
                                        filterUnitTerms.push({name: u[term][uKey], type: term})
                                    }
                                }
                            } else {
                                let object = {};
                                if (u[term] !== "" && u[term] !== null) {
                                    if(u.unit_type === "mock"){
                                        if (term === 'animated') {
                                            object.type = 'additional_features';
                                            object.name = "Animated Mock";
                                            filterUnitTerms.push(object)
                                        }
                                        if (term === 'proactive_proposal') {
                                            object.type = 'additional_features';
                                            object.name = "Proactive Proposal";
                                            filterUnitTerms.push(object)
                                        }
                                    }
                                    if(u.unit_type === "live"){
                                        if (term === "ppt_location") {
                                            object.type = 'additional_features';
                                            object.name = 'Live PPT';
                                            filterUnitTerms.push(object)
                                        }
                                    }
                                    if (term === 'favorite_id') {
                                        object.type = 'additional_features';
                                        object.name = "Best in Class";
                                        filterUnitTerms.push(object)
                                    }
                                    if (term === 'thumbnail_device_name') {
                                        object.type = 'search_by_device';
                                        object.name = u[term];
                                        filterUnitTerms.push(object)
                                    }
                                    if (term === "seller") {
                                        object.type = term;
                                        object.name = u[term];
                                        filterUnitTerms.push(object)
                                    }
                                }
                            }
                        }else{
                            for (const termKey in options) {
                                let item = options[termKey];
                                if(item.title.includes('Search By Demo Type')){
                                    item.options = []
                                }
                                if(item.title.includes('Additional Features')){
                                    item.options = []
                                }
                                if(item.title.includes('Subcategory')){
                                    item.options = []
                                }
                            }
                        }
                    })
                })
                filterUnitTerms = filterUnitTerms.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.type === value.type && t.name === value.name
                        ))
                )
                if (mainSearch.length > 3) {
                    options.filter(o => {
                        o.options.filter(innerOption => {
                            for (const msItems in mainSearch) {
                                if (!search_term.includes(innerOption)) {
                                    if (innerOption.name === mainSearch[msItems].name && innerOption.type === mainSearch[msItems].type) {
                                        innerOption.selected = true;
                                        innerOption.main = true;
                                        search_term.push(innerOption);
                                    }
                                }
                            }
                        })
                    })
                }
                if (foptions.length > 0) {
                    options.map(o => {
                        o.options.map(innerOption => {
                            for (const fItems in foptions) {
                                let term = foptions[fItems];
                                let type = term.type.replace('filter_', '');
                                if (type === innerOption.type && innerOption.name === term.name) {
                                    innerOption.selected = true;
                                    search_term.push(innerOption)
                                }
                            }
                        })
                    })
                }
                let merged = [...search_term, ...filterUnitTerms];
                merged = merged.filter((v, i, a) => a.findIndex(v2 => {
                    let type = v2.type.replace('filter_', '');
                    return v.name === v2.name & v.type === type
                }) === i)
                let op = []
                let innerArray = [];

                merged.map(f => {
                    const exists = op.findIndex(element => {
                        element.options.filter(filterEle => {
                            return element.title === f.type && filterEle.type === f.type
                        })
                    }) > -1;
                    if (!exists) {
                        let obj = {}
                        obj.title = f.type;
                        innerArray.push(f)
                        obj.options = innerArray;
                        op.push(obj);
                    }

                })
                op = op.filter(fil => {
                    fil.options = fil.options.filter(fo => {
                        if (fil.title.toLowerCase() === fo.type.toLowerCase()) {
                            return fo
                        }
                    })
                    return fil
                })
                let updateOptions = [...this.props.searchObj];
                updateOptions.forEach(uo => {
                    for (const uoKey in op) {
                        if (op[uoKey].title === "additional_features") {
                            op[uoKey].title = "additional features";
                        }
                        if (op[uoKey].title === "search_by_demo_type") {
                            op[uoKey].title = "search by demo type";
                        }
                        if (op[uoKey].title === "search_by_device") {
                            op[uoKey].title = "search by device";
                        }
                        if (op[uoKey].title === uo.title.toLowerCase()) {
                            uo.options = op[uoKey].options;
                        }
                        if(!op.includes('search_by_demo_type')){
                            if(uo.title === "Search By Demo Type" && op[uoKey].length === 0){
                                uo.options = [];
                            }
                        }
                    }
                })
                updateOptions = updateOptions.map((arr) =>{
                    arr.options = arr.options.sort((a,b) => {
                       return a.name.localeCompare(b.name);
                    })
                    return arr
                })

                // }
                let title = "More"
                if (this.state.show === true && this.state.title !== title) {
                    this.setState({show: true, title, options: updateOptions})
                } else {
                    this.setState({show: !this.state.show, title, options: updateOptions})
                }
            }
            else{
                options = options.map((arr) =>{
                    arr.options = arr.options.sort((a,b) => {
                        return a.name.localeCompare(b.name);
                    })
                    return arr
                })
                let title = "More"
                if (this.state.show === true && this.state.title !== title) {
                    this.setState({show: true, title, options: options})
                } else {
                    this.setState({show: !this.state.show, title, options: options})
                }
            }
        }
        else {
            options = options.filter(o => {
                cat = cat === "Creative Format" ? 'Creative Type' : cat;
                if (cat === o.title) {
                    for (const oKey in o.options) {
                        let item = o.options[oKey];
                    }
                    return o;
                }
            })
            if(mainSearch.length < 3  || mainSearch.length > 3  || foptions.length > 0){
                cat = cat.toLowerCase();
                cat = cat === "functionality" ? 'functionalities' : cat;
                cat = cat === "vertical" ? 'verticals' : cat;
                cat = cat === "creative type" ? 'creative_type' : cat;
                this.props.pagination.allRecords.filter(u => {
                    if (u.hasOwnProperty(cat)) {
                        if(Array.isArray(u[cat])){
                            for (const uKey in u[cat]) {
                                if(u[cat][uKey].name !== null){
                                    if(cat === "functionalities"){
                                        filterUnitTerms.push({name: u[cat][uKey].name, type: 'functionality'})
                                    }
                                    if(cat === "verticals"){
                                        filterUnitTerms.push({name: u[cat][uKey].name, type: 'vertical'})
                                    }
                                    else{
                                        filterUnitTerms.push({name: u[cat][uKey].name, type: cat})
                                    }
                                }
                            }
                        }else{
                            let object = {};
                            object.type = cat;
                            object.name = u[cat];
                            filterUnitTerms.push(object)
                        }
                    }
                })
                if (mainSearch.length > 3) {
                   options.filter(o => {
                        o.options.filter(innerOption => {
                            for (const msItems in mainSearch) {
                                if(!search_term.includes(innerOption)) {
                                    if (innerOption.name === mainSearch[msItems].name && innerOption.type === mainSearch[msItems].type) {
                                        innerOption.selected = true;
                                        innerOption.main = true;
                                        search_term.push(innerOption);
                                    }
                                }
                            }
                        })
                    })
                }
                // check filter search vs options
                // add filtered options to filter terms
                if(foptions.length > 0){
                    options.forEach(o => {
                        o.options.forEach(innerOption => {
                            for (const fItems in foptions) {
                                if(!search_term.includes(innerOption.name)){
                                    let type = foptions[fItems].type.replace('filter_', '');
                                    if(innerOption.name === foptions[fItems].name && innerOption.type === type){
                                        innerOption.selected = true;
                                        search_term.indexOf(innerOption) === -1 ? search_term.push(innerOption) : console.log("This item already exists");
                                    }
                                }
                            }
                        })
                    })
                }
                let merged = [...search_term, ...filterUnitTerms];
                merged = merged.filter((v,i,a)=>a.findIndex(v2=>(v.name === v2.name))===i)
                let op = merged;
                op = op.sort((a, b) =>{
                    if(a.name !== null && b.name !== null){
                        return a.name.localeCompare(b.name);
                    }
                })
                let title = options[0].title;
                if (this.state.show === true && this.state.title !== title) {
                    this.setState({show: true, title, options: op})
                } else {
                    this.setState({show: !this.state.show, title, options: op})
                }
                // this.setState({show: !this.state.show, title, options: op})

            }else{
                let title = options[0].title;
                options[0].options = options[0].options.sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                })
                // this.setState({show: !this.state.show, title, options: options[0].options})
                if (this.state.show === true && this.state.title !== title) {
                    this.setState({show: true, title, options: options[0].options})
                } else {
                    this.setState({show: !this.state.show, title, options: options[0].options})
                }
            }
        }
    }
    handleClickOutside = (event) => {
        if(event.target.tagName === 'svg' || event.target.tagName === 'path' || event.target.className.includes("sort--term-container")){
            return
        }else{
            if(this.state.show && this.filterModal.current !== null && !this.filterModal.current.contains(event.target)){
                this.setState({
                    show: false,
                })
            }
        }
    }
    getSortClass = (column) => {
        let activeTerm = '';
        let classes = 'sort-column';

        this.state.filterOptions.map(at => {
            let type = at.type.replace("filter_", "");
            let moreArray = ["search_by_device", "seller", "search_by_demo_type", "subcategory", "additional_features"];
            if(type === "creative_type" && column === "Creative Format"){
                activeTerm = ' filter-active ';
            }
            if(column === "more"){
                if(moreArray.includes(type)){
                    activeTerm = ' filter-active ';
                }
            }
            if(column === "links"){
                if(type === "links"){
                    activeTerm = ' filter-active ';
                }
            }
            if(type === column.toLowerCase()){
                activeTerm = ' filter-active ';
            }
            if(type === 'from_date_format' && column === "date"){
                activeTerm = ' filter-active ';
            }
        })
        classes += activeTerm + ' sort-' + this.props.direction;
        return classes;
    };

    getFilters() {
        let chips = this.props.chips;
        let options = this.state.mainSearchOptions;
        let prevFilter = this.state.filterOptions;
        let primarySearch = [];
        let filterSearchOptions = [];
        for (let i in prevFilter) {
            let option1 = prevFilter[i];
            filterSearchOptions.push(option1.type + '[]=' + encodeURIComponent(option1.name).replace(/\s+/g, '+'))
        }
        for (const mainTerm in options) {
            let mainOptions = options[mainTerm];
            primarySearch.push(mainOptions.type + '[]=' + encodeURIComponent(mainOptions.name).replace(/\s+/g, '+'))
        }
        let searchParams  = primarySearch.concat(filterSearchOptions);
        return searchParams.join('&');
    }

    setSearchTerms = (options, choice) => {
        let filterSearchOptions = [];
        let primarySearch = [];
        let prevSearchOption = this.state.mainSearchOptions;
        let filterOptions = this.state.filterOptions;

        if(options !== undefined){
            if(Array.isArray(options)){
                let filter = [];
                if(filterOptions.length > 0){
                    filterOptions = [...options, ...filterOptions];
                    if(options.length > 0) {
                        filterOptions.filter((item) => {
                            return options.some(x => {
                                if (x.name !== item.name) {
                                    filter.push(x)
                                }
                                if (x.type !== item.type) {
                                    filter.push(item)
                                }
                            })
                        })
                        if(filter.length > 0){
                            filterOptions = filter;
                        }
                    }else{
                        let name = choice.toLowerCase();
                        filterOptions = filterOptions.filter(fil => {
                            if(!fil.type.includes(name)){
                                return fil
                            }
                        })
                    }

                }else{
                    filterOptions = options;
                }

                filterOptions = filterOptions.filter((v,i,a)=>a.findIndex(v2=>(v.name === v2.name && v.type === v2.type))===i)

                for (let i in filterOptions) {
                    let option1 = filterOptions[i]
                    filterSearchOptions.push(option1.type + '[]=' + encodeURIComponent(option1.name).replace(/\s+/g, '+'))
                }
                for (const mainTerm in prevSearchOption) {
                    let mainOptions = prevSearchOption[mainTerm];
                    primarySearch.push(mainOptions.type + '[]=' + encodeURIComponent(mainOptions.name).replace(/\s+/g, '+'))
                }
            }else{
                let dateArray = [];
                for (const property in options) {
                    let dateObj = {};
                    dateObj.type = property;
                    dateObj.name = options[property];
                    if(filterOptions.length > 0){
                        for (const prev in filterOptions) {
                            let prevOption = filterOptions[prev];
                            if(property === prevOption.type){
                                dateObj.name = options[property];
                            }
                        }
                    }
                    dateArray.push(dateObj);
                }
                for (const filterKey in filterOptions) {
                    let fItem = filterOptions[filterKey];
                    if(!fItem.type.includes('date') && !fItem.type.includes('sort')){
                        if(!dateArray.includes(filterOptions[filterKey])){
                            dateArray.push({type: fItem.type, name: fItem.name})
                        }
                    }

                }
                filterOptions = dateArray;
                for (let x in dateArray) {
                    let option2 = dateArray[x];
                    filterSearchOptions.push(option2.type + '[]=' + encodeURIComponent(option2.name).replace(/\s+/g, '+'))
                }
                for (const mainTerm in prevSearchOption) {
                    let mainOptions = prevSearchOption[mainTerm];
                    primarySearch.push(mainOptions.type + '[]=' + encodeURIComponent(mainOptions.name).replace(/\s+/g, '+'))
                }
            }
        }
        let searchParams  = primarySearch.concat(filterSearchOptions);
        this.setState(prevState => ({
            filterOptions: filterOptions,
            mainSearchOptions: prevSearchOption,
            show: false
        }));
        this.props.history.push(`/search?${searchParams.join('&')}`);
        this.props.dispatch(fetchSearchResults(1, searchParams));
        // this.props.dispatch(getFilter(searchObject));

    }
    clearAll = (title, options) => {
        let subject = title.toLowerCase();
        let filter = this.state.filterOptions;
        if(subject === "creative format"){
            subject = "creative_type"
        }
        if(subject === "more" && options.length > 0){
            filter = filter.filter(filterKey => {
                let type = filterKey.type.replace("filter_", "");
                for (const op in options) {
                    if(options[op].type !== type){
                        return filterKey
                    }
                }
            })
        }else{
            filter = filter.filter(filterKey => {
                let type = filterKey.type.replace("filter_", "")
                if(subject !== type){
                    return filterKey
                }
            })
        }
        this.props.dispatch(fetchSearchData());
        this.setState({filterOptions: filter})

    }

    resetFilter = () => {
        let options = this.state.mainSearchOptions;
        let filterInfo = this.state.options;
        let searchOptions = [];
        if(options !== undefined){
            for (let i in options) {
                let option1 = options[i];
                searchOptions.push(option1.type + '[]=' + encodeURIComponent(option1.name).replace(/\s+/g, '+'))
            }
        }
        filterInfo.map(m => {
            if(m.options !== undefined & Array.isArray(m.options)){
               m.options = m.options.map(o => {
                   o.selected = false
                   return o
               })
            }else{
                m.selected = false
            }
            return m;
        })
        this.setState({filterOptions: [], options: filterInfo, show: false})
        this.props.history.push(`/search?${searchOptions.join('&')}`);
        this.props.dispatch(fetchSearchData());
        this.props.dispatch(clearSearchFilter());
        this.props.dispatch(fetchSearchResults(1, searchOptions));
        this.props.dispatch(getFilter(options));
    }
    onHover = () => {
        this.setState({hover: true})
    };

    onLeave = () => {
        this.setState({hover: false})
    }

    displayHeadline = () => {
        let searchTerms = [...this.props.mainSearch];
        let show = false;
        let text = "";
        let mock = searchTerms.some(m => m.name === "Mock Unit");
        let live = searchTerms.some(l => l.name === "Live Unit");
        let matchAny = searchTerms.some(ma => ma.type === "any" && ma.name === true);
        let logicText = " and ";
        let containingArray = [];
        let filteredArray = [];
        let filterByText = ""
        let filterBy = [...this.state.filterOptions];
        searchTerms.forEach(item => {
            if(item.type !== "unit_type" && item.type !== "any"){
                containingArray.push(item.name);
            }
        });
        filterBy.forEach(item => {
            if(item.type !== "unit_type" && item.type !== "any"){
                filteredArray.push(item.name);
            }
        });
        if(mock && live){
            text = "all entries";
        }else if(mock && !live){
            text = '"Mockups"'
        }else{
            text = '"Live Units"'
        }
        if(matchAny){
            logicText = " or "
        }
        if(filterBy.length > 0){
            filterByText = " filtered by: ";
        }
        let fil = filterBy.length > 0 ? filterByText + filteredArray.join(' and ') : ""
        let width = ''
        if(this.header.current !== null){
            width = this.header.current.offsetWidth
            if(this.state.hover && width > 1100){
                show = true;
            }
        }

        return(
            <React.Fragment>
                <h2 className="search-display-modal-text" onMouseEnter={this.onHover} onMouseLeave={this.onLeave}>
                    <span ref={this.header} >Displaying {text} {containingArray.length > 0 ? " containing: " + '"' +containingArray.join('"'+logicText+'"') + '"' + fil : fil}</span>
                </h2>
                {show &&
                    <div className="search-header-tooltip">
                        <p className="search-header-tooltip-p">Displaying {text} {containingArray.length > 0 ? "containing: " + '"' + containingArray.join('"' + logicText + '"') + '"' + fil : fil}</p>
                    </div>
                }
            </React.Fragment>
        )

    }
    render() {
        const {pagination, loading, column, direction } = this.props;
        return (
            <div className="search-wrapper">
                <div className="search-header">
                    {this.displayHeadline()}
                    <div className="search-filter-reset-container">
                        <span className="reset--filter-btn" onClick={this.resetFilter}>Reset Filters</span>
                        <div className="search-view-right">
                            <Pagination
                                totalRecords={pagination.total_records}
                                pageLimit={pagination.page_limit}
                                currentPage={pagination.current_page}
                                totalPages={pagination.total_pages}
                                loading={loading}
                                route="/search"
                                filter={this.getFilters()}
                                column={column}
                                direction={direction}
                                history={this.props.history}
                            />
                        </div>
                    </div>
                </div>
                {loading ? <Loading /> : pagination.total_records === 0 ? <h1 className="text-center">No results found.</h1> :
                    <div className="search-table-wrapper">
                        <table className="table table-sort brand-table search-table" id="filter-table-content">
                            <thead>
                            <tr>
                                <th className="creative-tr">Creative</th>
                                <th className={this.getSortClass('Creative Format') + 'cf'}>
                                    <div className={`sort--term-container ${this.state.show && this.state.title === "Creative Type" ? "active" : ""}`} onClick={(e) =>this.handleSortClick(e,'Creative Format')}>
                                        Creative Format
                                        <span className="caret">
                                            <SVG src={caretDown}/>
                                        </span>
                                    </div>
                                    {this.state.show && this.state.title === "Creative Type" && (
                                        <div id="ct">
                                            <FilterModal
                                                innerRef={(node) => { this.filterModal.current = node; }}
                                                options={this.state.options}
                                                terms={this.state.mainSearchOptions}
                                                filterItems={this.state.filterOptions}
                                                setSearchTerms={this.setSearchTerms}
                                                clear={this.clearAll}
                                                units={this.props.units}
                                                chips ={this.props.chips}
                                                title="Creative Format"/>
                                        </div>)}
                                </th>
                                <th className={this.getSortClass('Brand') + 'brand'}>
                                    <div className={`sort--term-container ${this.state.show && this.state.title === "Brand" ? "active" : ""}`} onClick={(e) => this.handleSortClick(e,'Brand')}>
                                        Brand
                                        <span className="caret">
                                            <SVG src={caretDown}/>
                                        </span>
                                    </div>
                                    {this.state.show && this.state.title === "Brand" &&
                                        (<FilterModal
                                            innerRef={(node) => { this.filterModal.current = node; }}
                                            options={this.state.options}
                                            terms={this.state.mainSearchOptions}
                                            filterItems={this.state.filterOptions}
                                            setSearchTerms={this.setSearchTerms}
                                            clear={this.clearAll}
                                            units={this.props.units}
                                            chips ={this.props.chips}
                                            title="Brand"/>)}

                                </th>
                                <th className={this.getSortClass('Campaign') + 'campaign'} >
                                    <div className={`sort--term-container ${this.state.show && this.state.title === "Campaign" ? "active" : ""}`} onClick={(e) => this.handleSortClick(e,'Campaign')}>
                                        Campaign
                                        <span className="caret">
                                            <SVG src={caretDown}/>
                                        </span>
                                    </div>
                                    {this.state.show && this.state.title === "Campaign" &&
                                        (<FilterModal
                                            innerRef={(node) => { this.filterModal.current = node; }}
                                            options={this.state.options}
                                            terms={this.state.mainSearchOptions}
                                            filterItems={this.state.filterOptions}
                                            setSearchTerms={this.setSearchTerms}
                                            units={this.props.units}
                                            clear={this.clearAll}
                                            chips ={this.props.chips}
                                            title="Campaign"/>)}

                                </th>
                                <th className={this.getSortClass('Vertical') + 'vert'}>
                                    <div className={`sort--term-container ${this.state.show && this.state.title === "Vertical" ? "active" : ""}`} onClick={(e) => this.handleSortClick(e,'Vertical')}>
                                        Vertical
                                        <span className="caret">
                                            <SVG src={caretDown}/>
                                        </span>
                                    </div>
                                    {this.state.show && this.state.title === "Vertical" && (
                                        <FilterModal
                                            innerRef={(node) => { this.filterModal.current = node; }}
                                            options={this.state.options}
                                            terms={this.state.mainSearchOptions}
                                            filterItems={this.state.filterOptions}
                                            setSearchTerms={this.setSearchTerms}
                                            clear={this.clearAll}
                                            units={this.props.units}
                                            chips ={this.props.chips}
                                            title="Vertical"
                                            id="vertical"/>
                                    )}

                                </th>
                                <th className={this.getSortClass('Functionality') + 'functionality'}>
                                    <div className={`sort--term-container ${this.state.show && this.state.title === "Functionality" ? "active" : ""}`} onClick={(e) =>this.handleSortClick(e,'Functionality')}>Functionality
                                        <span className="caret">
                                            <SVG src={caretDown}/>
                                        </span>
                                    </div>
                                    {this.state.show && this.state.title === "Functionality" &&
                                        <FilterModal
                                            innerRef={(node) => { this.filterModal.current = node; }}
                                            options={this.state.options}
                                            terms={this.state.mainSearchOptions}
                                            filterItems={this.state.filterOptions}
                                            setSearchTerms={this.setSearchTerms}
                                            clear={this.clearAll}
                                            chips ={this.props.chips}
                                            units={this.props.units}
                                            title="Functionality"
                                            id="functionality"
                                        />
                                    }
                                </th>
                                <th className={this.getSortClass('Designer') + 'designer'}>
                                    <div className={`sort--term-container ${this.state.show && this.state.title === "Designer" ? "active" : ""}`} onClick={(e) => this.handleSortClick(e,'Designer')}>
                                        Designer
                                        <span className="caret">
                                            <SVG src={caretDown}/>
                                        </span>
                                    </div>
                                    {this.state.show && this.state.title === "Designer" &&
                                        (<FilterModal
                                            innerRef={(node) => { this.filterModal.current = node; }}
                                            options={this.state.options}
                                            terms={this.state.mainSearchOptions}
                                            filterItems={this.state.filterOptions}
                                            setSearchTerms={this.setSearchTerms}
                                            clear={this.clearAll}
                                            units={this.props.units}
                                            chips ={this.props.chips}
                                            title="Designer"/>)}
                                </th>
                                <th className={this.getSortClass('date')  + 'date'} >
                                    <div className={`sort--term-container ${this.state.show && this.state.title === "date" ? "active" : ""}`} onClick={(e) =>this.handleSortClick(e,'date') }>Date
                                        <span className="caret">
                                            <SVG src={caretDown}/>
                                        </span>
                                    </div>
                                    {this.state.show && this.state.title === "date" &&
                                        <DateFilterModal
                                            innerRef={(node) => { this.filterModal.current = node; }}
                                            options={this.state.options}
                                            setSearchTerms={this.setSearchTerms}
                                            filterItems={this.state.filterOptions}
                                            chips ={this.props.chips}
                                            terms={this.state.mainSearchOptions}
                                            title="date"/>}
                                </th>
                                <th  className={this.getSortClass('links')  + 'links'}>
                                    <div className={`sort--term-container ${this.state.show && this.state.title === "links" ? "active" : ""}`} onClick={(e) =>this.handleSortClick(e,'links') }>Links
                                        <span className="caret">
                                            <SVG src={caretDown}/>
                                        </span>
                                    </div>
                                    {this.state.show && this.state.title === "links" &&
                                        (<FilterModal
                                            innerRef={(node) => { this.filterModal.current = node; }}
                                            options={this.state.options}
                                            terms={this.state.mainSearchOptions}
                                            setSearchTerms={this.setSearchTerms}
                                            filterItems={this.state.filterOptions}
                                            clear={this.clearAll}
                                            chips ={this.props.chips}
                                            title="Links"/>)}
                                </th>
                                <th className={this.getSortClass('more')  + 'more'}>
                                    <div className={`sort--term-container ${this.state.show && this.state.title === "More" ? "active" : ""}`} onClick={(e) =>this.handleSortClick(e,'more') }>More...
                                        <span className="caret">
                                            <SVG src={caretDown}/>
                                        </span>
                                    </div>
                                    {this.state.show && this.state.title === "More" &&
                                        (<FilterModal
                                            innerRef={(node) => { this.filterModal.current = node; }}
                                            options={this.state.options}
                                            terms={this.state.mainSearchOptions}
                                            filterItems={this.state.filterOptions}
                                            units={this.props.units}
                                            setSearchTerms={this.setSearchTerms}
                                            clear={this.clearAll}
                                            chips ={this.props.chips}
                                            title="More"/>)}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                {this.props.units.map((row, key) => (
                                    <SearchRow key={key} row={row} />
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
                <div className="bottom-pag-container">
                    <div className="search-view-bottom">
                        <Pagination
                            totalRecords={pagination.total_records}
                            pageLimit={pagination.page_limit}
                            currentPage={pagination.current_page}
                            totalPages={pagination.total_pages}
                            loading={loading}
                            route="/search"
                            filter={this.getFilters()}
                            column={column}
                            direction={direction}
                            history={this.props.history}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    searchObj: state.search.searchObject,
    mainSearch: state.search.mainSearch,
    chips: state.search.chips,
    units: state.search.units,
    pagination: state.search.pagination,
    loading: state.search.loading,
    column: state.search.column,
    direction: state.search.direction,
    active: state.search.active
});

export default connect(mapStateToProps)(Search);
